import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.441 19.549A9.961 9.961 0 0 0 12 22c2.51 0 4.803-.924 6.559-2.451a7.003 7.003 0 0 0-13.118 0zm-.775-.75a8.023 8.023 0 0 1 4.91-4.425 5 5 0 1 1 4.849 0 8.023 8.023 0 0 1 4.909 4.424A9.965 9.965 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.965 9.965 0 0 0 2.666 6.798zM12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm0-9a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
});

var SvgAccount = function SvgAccount(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgAccount;